import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = ["disabled"];
var _hoisted_2 = {
  key: 0,
  "class": "btn-spinner mr-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("button", {
    disabled: $props.loading,
    "class": "flex items-center"
  }, [$props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 8, _hoisted_1);
}